import config from "../config";
import { axios_server, handleRequestError, payment_backend } from ".";
import router from "next/router";
import { toast } from "sonner";
import { createHeaderToken } from "../helpers";
import posthog from "posthog-js";

export const handleDowngradeSubscription = async (
  setLoading: (by: boolean) => void,
  id?: string,
  teamId?: string,
) => {
  setLoading(true);
  const payload = {
    subscription_id: id,
  };
  posthog.capture("Downgrade Subscription", payload);

  const url = `/subscription/downgrade/${teamId || ""}`;

  const downgradePromise = payment_backend.post(url, payload);
  toast.promise(downgradePromise, {
    loading: "Downgrading subscription...",
    success: () =>
      "Subscription downgraded successfully, changes should reflect in a few minutes",
    error: (error: any) => handleRequestError(error, "return"),
    finally: () => setLoading(false),
  });
};

export const handleRenewSubscription = async (
  setRenewSubscription: (loading: boolean) => void,
  payload: {
    invoiceId: string;
  },
) => {
  const paymentPromise = payment_backend.post("/payment/pay", payload);

  posthog.capture("Renew Subscription", payload);

  return toast.promise(paymentPromise, {
    loading: "Attempting to pay invoice...",
    success: () => {
      return "Payment completed successfully";
    },
    error: (error: any) => {
      return error?.response?.data?.message || "An error occurred";
    },
    finally: () => {
      setRenewSubscription(false);
    },
  });
};

export const HandleUpgradeToProAccount = async (
  setLoading: (loading: boolean) => void,
  cardId: string,
) => {
  const payload = {
    accept_terms: true,
    type: "DEVELOPER_PLAN",
    card_id: cardId,
  };
  posthog.capture("Upgrade To Pro Subscription", payload);
  try {
    setLoading(true);
    await payment_backend.post("/subscription/create", payload);
    setTimeout(() => {
      router.push(
        `/success?type=subscription&redirectToken=${encodeURIComponent(
          createHeaderToken({ payload }, 5),
        )}`,
      );
    }, 1500);
  } finally {
    setLoading(false);
  }
};

export const verifyStartupCode = async (code: string) => {
  return await axios_server.post(
    config.PAYMENT_BASE_URL + "/startup/validate",
    {
      code,
    },
  );
};
